export default {
  baseURL: process.env.VUE_APP_BASE_URL,
  oftURL: process.env.VUE_APP_OFT_URL
}
